import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import Doses from '@/icons/Doses.vue';
import Attention from '@/icons/Attention.vue';
import Item from '@/icons/Item.vue';
import Share from '@/icons/Share.vue';
import Interactions from '@/icons/Interactions.vue';
import "@mdi/js";

Vue.use(Vuetify);
//004662
export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#004662',
        secondary: "#00728a"
      }
    }
  }, icons: {
    iconfont: 'mdiSvg',
    values: {
      doses: { component: Doses },
      attention: { component: Attention },
      item: { component: Item },
      share: { component: Share },
      interactions: { component: Interactions },
    }
  }
});
